<template>
  <div class="page_mulu page_shadow2">
      
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.page_shadow2 {
  height: 1300px;
  width: 900px;
  margin-bottom: 20px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  display: flex;
  align-items: center;
}
/* .page_end_bg{
    width: 100%;
    height: 300px;
    background: #1D9BAC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.page_end_bg h3{
    font-size: 60px;
    color: #fff;
}
.page_end_bg p{
    color: #fff;
    font-size: 24px;
} */
.page_end_bg{
    width: 100%;
    height: 321px;
    background: url("../../../../../public/imgs/cepingreport/end.png");
    background-size: cover;
}
</style>